import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function EnablePasswordTextField({ value, error, onChange, passwordChanged, onChangePasswordClick }) {

    useEffect(() => {
        /*  if (anotherSectionActive) {
             validationService.cleanValidation('enablePassword');
             onChange('');
         } else { */
        validationService.validateNotEmpty(value, 'enablePassword')
        // }
        return () => validationService.cleanValidation('enablePassword');
    }, [value])

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="enablePasswordText">Enable Password <span className="modal-v2-required-mark">*</span></label>
                <div className="modal-v2-field-action-row">
                    <input className={`form-control oct_field ${error && 'border-danger'}`}
                        id="enablePasswordText"
                        type="password"
                        value={value}
                        disabled={!passwordChanged}
                        onChange={event => onChange(event.target.value)} />
                    {!passwordChanged
                        && value
                        && <button type="button"
                            className="modal-v2-btn modal-v2-btn-primary modal-v2-inline-change-btn"
                            onClick={() => onChangePasswordClick()}>
                            Change
                        </button>}
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("EnablePasswordTextField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.enablePassword
    }
}

export default connect(mapStateToProps)(EnablePasswordTextField);
